import React from 'react';
import { StethoscopeIcon } from 'lucide-react';
export function PrescriptionRequired() {
  return <div className="rounded-xl border-2 border-amber-200 bg-amber-50 p-6 shadow-sm" data-id="element-4938" data-mp="2npk988e06ba6">
      <div className="mb-4 flex items-start" data-id="element-4939" data-mp="2spewm1ykkiqh">
        <div className="mr-3 rounded-full bg-white p-2" data-id="element-4940" data-mp="2snlqcnrvc0j0">
          <StethoscopeIcon className="h-6 w-6 text-amber-700" data-id="element-4941" data-mp="2wr9xj5cl8u3q" />
        </div>
        <div className="flex-1" data-id="element-4942" data-mp="31puyx83ktjtr">
          <h3 className="text-base font-bold text-gray-900 mb-2" data-id="element-4943" data-mp="31qmuiix6bhk1">
            This Product Requires a Prescription
          </h3>
          <p className="text-sm text-gray-700" data-id="element-4944" data-mp="36ndal68zad5g">
            You need a prescription, you can request it through the following
            button
          </p>
        </div>
      </div>
      <button className="flex w-full items-center justify-center gap-2 rounded-lg bg-brand px-6 py-3 font-bold text-white transition-colors duration-150 hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-4945" data-mp="3gdg0uyoptd03">
        <StethoscopeIcon className="h-5 w-5" data-id="element-4946" data-mp="3mlxcygpwgq3c" />
        Consult a Doctor
      </button>
    </div>;
}